//lib
import { Icon } from "@iconify/react/dist/iconify.js";

//redux
import { useSelector } from "react-redux";

//component
import Col from "../../../components/element/col";
import Row from "../../../components/element/row";
import Image from "../../../components/element/image";
import { Hero1, Hero2, Hero3, Logo, Sample } from "../../../assets/images";
import Button from "../../../components/element/button";
import ArrowButton from "../../../components/common/common.arrow.button";
import Container from "../../../components/element/container";
import { Pagination, Navigation, Autoplay, EffectFade } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { useRef, useState } from "react";
import useWindowDimension from "../../../components/hook/use.window.dimension";
import { useNavigate } from "react-router-dom";

export default function HomeHero() {
  const swiperRef = useRef(null);
  const navigate = useNavigate();
  const { width } = useWindowDimension();
  const [activeSwiper, setActiveSwiper] = useState(0);

  const handleNavigate = () => {
    navigate("/shop/all");
  };

  const heroList = [
    {
      image: Hero1,
      title: <>The DC V12 {width > 750 && <br />} Collection</>,
      subtitle:
        "The DC V12 Collection merges high-performance style with luxury, featuring sleek designs, premium fabrics, and motorsport-inspired details for a bold, speed-driven look.",
    },
    {
      image: Hero3,
      title: <>The GT3 Porsche {width > 750 && <br />} Collection</>,
      subtitle:
        "For speed lovers and style chasers. The GT3 Porsche Tee fuses clean streetwear with motorsport energy — featuring racing stripes and the iconic GT3 RS rear view.",
    },
    {
      image: Hero2,
      title: <>D'CONCEPT {width > 750 && <br />}Classic Crest</>,
      subtitle:
        "Timeless and rened. The D'CONCEPT Classic Crest Tee blends minimal luxury with heritage style — featuring crown logo and founding year, perfect for casual elegance.",
    },
  ];

  return (
    <Container className="w-100">
      <Swiper
        // key={Date.now()}
        className="hero-swiper"
        rewind={true}
        pagination={true}
        navigation={true}
        slidesPerView="auto"
        modules={[Navigation, Pagination, EffectFade, Autoplay]}
        effect="fade"
        allowTouchMove={false}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
        }}
        onSlideChange={(swiper) => setActiveSwiper(swiper.activeIndex)}
      >
        {heroList.map((hero, heroIndex) => (
          <SwiperSlide key={heroIndex} className="home-hero">
            <Col className="_col hero-col">
              <h1 className="_label hero-title">{hero.title}</h1>
              <p className="_label hero-subtitle">{hero.subtitle}</p>
              <Button className="_button" onClick={() => handleNavigate()}>
                Explore More
              </Button>
            </Col>
            <Col className="relative h-100">
              <Image src={hero.image} className="_img hero" />
              <ArrowButton
                exploreMore
                // color="white"
                onClick={() => handleNavigate()}
              />
              <Col className="common-swiper-function --black">
                <Col className="v-flex gap-2">
                  {heroList.map((hero, heroIndex) => (
                    <article
                      className={`common-swiper-progress ${
                        activeSwiper === heroIndex ? "--active" : ""
                      }`}
                    />
                  ))}
                </Col>
                <Col className="v-flex gap-3">
                  <Button
                    className="common-swiper-button prev"
                    onClick={() =>
                      swiperRef.current && swiperRef.current.slidePrev()
                    }
                  >
                    <Icon
                      icon="fluent:arrow-sort-up-20-regular"
                      className="_svg"
                    />
                  </Button>
                  <Button
                    className="common-swiper-button next"
                    onClick={() =>
                      swiperRef.current && swiperRef.current.slideNext()
                    }
                  >
                    <Icon
                      icon="fluent:arrow-sort-down-20-regular"
                      className="_svg"
                    />
                  </Button>
                </Col>
              </Col>
            </Col>
          </SwiperSlide>
        ))}
      </Swiper>
    </Container>
  );
}
